module.exports = __webpack_public_path__ + "img/wz-8-2-2.5d8069de.jpg";